export const contractTypes = {
  arrangementTrip: "Arrangement Trip",
};
